import { render, staticRenderFns } from "./ShapeIcon.vue?vue&type=template&id=e628b828&scoped=true&"
import script from "./ShapeIcon.vue?vue&type=script&lang=js&"
export * from "./ShapeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShapeIcon.vue?vue&type=style&index=0&id=e628b828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e628b828",
  null
  
)

export default component.exports